import { Component, OnInit } from '@angular/core';
import { ChaosTableService } from '../chaos-table.service';
import { ActivatedRoute } from '@angular/router';
import { ChaosTableHistoryRow } from '../types/chaos-table-history-row';
import { convertDateAndTime, removeUndefined } from '../../shared/helper-functions';
import { PageEvent } from '@angular/material/paginator';
import { FormBuilder, FormControl, FormGroup } from '@angular/forms';

@Component({
   selector: 'app-chaos-table-history',
   templateUrl: './chaos-table-history.component.html',
   styleUrls: ['./chaos-table-history.component.css']
})
export class ChaosTableHistoryComponent implements OnInit {
   displayedColumns: string[] = [
      'id',
      'columnName',
      'oldValue',
      'newValue',
      'modifyingUser',
      'modificationDate'
   ];

   dataSource: ChaosTableHistoryRow[] = [];

   total = 0;

   page = 0;

   pageSize = 20;

   selectedModifyingUser: string | undefined;

   selectedId: number | undefined;

   form: FormGroup;

   activeFilter: { id?: string; modifyingUser?: string } = {};

   constructor(
      private chaosTableService: ChaosTableService,
      private route: ActivatedRoute,
      private fb: FormBuilder
   ) {
      this.form = this.fb.group({
         id: new FormControl(),
         modifyingUser: new FormControl()
      });
   }

   ngOnInit(): void {
      const rowId = Number.parseInt(this.route.snapshot.queryParamMap.get('rowId') ?? '');

      if (!isNaN(rowId)) {
         this.selectedId = rowId;
         this.form.controls.id.setValue(this.selectedId);
      }

      this.getPage();
   }

   getPage() {
      this.chaosTableService
         .getHistory(
            removeUndefined({
               page: this.page,
               pageSize: this.pageSize,
               modifyingUser: this.selectedModifyingUser,
               id: this.selectedId
            })
         )
         .subscribe(data => {
            this.dataSource = data.list;
            this.total = data.count;
         });
   }

   onPageChange(pageEvent: PageEvent) {
      this.page = pageEvent.pageIndex;
      this.pageSize = pageEvent.pageSize;
      this.getPage();
   }

   onFilter() {
      this.selectedModifyingUser = this.form.controls.modifyingUser.value;
      this.selectedId = Number.parseInt(this.form.controls.id.value);
      if (isNaN(this.selectedId)) this.selectedId = undefined;
      if (this.selectedModifyingUser?.length == 0) this.selectedModifyingUser = undefined;
      this.getPage();
   }

   onClearFilter() {
      this.selectedModifyingUser = undefined;
      this.selectedId = undefined;
      this.form.reset();
      this.getPage();
   }

   convertDateAndTime(date: string | Date, timezone?: string): string {
      return convertDateAndTime(date, timezone);
   }
}
